<span *ngIf="showBadge" class="badge position-absolute top-1 start-100 translate-middle p-1" [class]="classes">
  <span class="visually-hidden"></span>
</span>
